import { concat, fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import EmberFlatpickr from 'ember-flatpickr/components/ember-flatpickr';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';
import moment from 'moment';

import Button from 'umg-ember-backend/components/ui/button';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class RecordExplorerToolbarFiltersDateComponent extends Component {
  // Getter and setter
  get selected() {
    return this.args.activeFilters[this.args.filter.key];
  }

  // Functions
  setFilter = (filter, selected) => {
    let filters = this.args.activeFilters;

    if (selected) {
      let date = moment(selected[0]).format('Y-M-D');

      filters[filter.key] = date;
    } else {
      delete filters[filter.key];
    }

    this.args.onChangeFilter(filters);
  };

  // Template
  <template>
    <div class={{(bem)}} ...attributes>
      <EmberFlatpickr
        @altInput={{true}}
        @altInputClass={{bem 'input'}}
        @altFormat='d.m.Y'
        @ariaDateFormat='d.m.Y'
        @date={{or this.selected null}}
        @dateFormat='Y-m-d'
        @onChange={{fn this.setFilter @filter}}
        @weekNumbers={{true}}
        placeholder={{t
          'tables.placeholder-filter'
          filter=(t (concat 'tables.filters.' @filter.key))
        }}
      />

      {{#if this.selected}}
        <Button
          class={{bem 'clear'}}
          @style='outline'
          @icon='close'
          @iconClass='u-color-error'
          {{on 'click' (fn this.setFilter @filter null (hash))}}
        />
      {{/if}}
    </div>
  </template>
}
